export enum AccountSettingsTab {
  PROFILE = "Profile",
  SECURITY = "Security",
  NOTIFICATIONS = "Notifications",
  WORKING_HOURS = "Working Hours",
  AGENT_SETTINGS = "Agent Settings"
}
